// extracted by mini-css-extract-plugin
export default {"pageWithHeader":"Radio_pageWithHeader__E-ung","ant-wave":"Radio_ant-wave__gM4ZK","radio":"Radio_radio__Qe5+k"};